module.exports = __webpack_public_path__ + "img/17864_S.36efbd58.png";